import axios from "axios"
import { Storage, Tools, Validator } from "../util"
import UsuarioService from "./UsuarioService"
import Environment from "./Environment"

const controller = "/app"

const AppService = {
    activarOpcion: (opcId) => {
        return opcId && UsuarioService.getUsuario().opciones
            ? UsuarioService.getUsuario().opciones.includes(opcId)
            : false
    },
    // checkAppVersion: () => {
    //     const app_version = Storage.getValue("app_version")
    //     if (Validator.isNotNull(app_version)) {
    //         // * verificar si existe una session activa
    //         if (Validator.isNotNull(UsuarioService.getUsuario())) {
    //             // * si la app_version guardado en el localstorage es diferente al que se encuentra en el Environment
    //             // * obligar al usuario a iniciar sesion nuevamente
    //             if (Environment.version != app_version) {
    //                 UsuarioService.logout()
    //             }
    //         } else {
    //             // * colocando el app_version en el localstorage
    //             Storage.setValue("app_version", Environment.version)
    //         }
    //     } else {
    //         // * colocando el app_version en el localstorage
    //         Storage.setValue("app_version", Environment.version)
    //     }
    // },
    // [**] este metodo deberia deprecarse...
    getData: async (request) => {
        const { data } = await axios.post(`${controller}/getData`, request)
        return data
    },
}

export default AppService